import { Routes } from '@angular/router';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // Theme-specific login routes
  {
    path: 'login/dbp',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    data: { theme: 'default' }
  },
  {
    path: 'login/veefin',
    loadComponent: () => import('./pages/login/login-veefin.component').then(m => m.LoginVeefinComponent),
    data: { theme: 'veefin' }
  },
  {
    path: 'login/pbcom',
    loadComponent: () => import('./pages/login/login-pbcom.component').then(m => m.LoginPbcomComponent),
    data: { theme: 'pbcom' }
  },
  // Default login redirects to DBP
  {
    path: 'login',
    redirectTo: 'login/veefin',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'template-builder',
        loadChildren: () => import('./pages/template-builder/template-builder.routes').then(m => m.TEMPLATE_BUILDER_ROUTES)
      },
      {
        path: 'users',
        loadChildren: () => import('./pages/users/users.routes').then(m => m.USERS_ROUTES)
      },
      {
        path: 'corporates',
        loadChildren: () => import('./pages/corporates/corporates.routes').then(m => m.CORPORATES_ROUTES)
      },
      {
        path: 'treasury',
        loadChildren: () => import('./pages/treasury/treasury.routes').then(m => m.TREASURY_ROUTES)
      },
      {
        path: 'lending',
        loadChildren: () => import('./pages/lending/lending.routes').then(m => m.LENDING_ROUTES)
      },
      {
        path: 'cards',
        loadChildren: () => import('./pages/cards/cards.routes').then(m => m.CARDS_ROUTES)
      },
      {
        path: 'investments',
        loadChildren: () => import('./pages/investments/investments.routes').then(m => m.INVESTMENTS_ROUTES)
      },
      {
        path: 'approvals',
        loadChildren: () => import('./pages/approvals/approvals.routes').then(m => m.APPROVALS_ROUTES)
      },
      {
        path: 'audit',
        loadChildren: () => import('./pages/audit/audit.routes').then(m => m.AUDIT_ROUTES)
      },
      {
        path: 'swift',
        loadChildren: () => import('./pages/swift/swift.routes').then(m => m.SWIFT_ROUTES)
      },
      {
        path: 'payment-rails',
        loadChildren: () => import('./pages/payment-rails/payment-rails.routes').then(m => m.PAYMENT_RAILS_ROUTES)
      },
      {
        path: 'bulk-payment',
        loadChildren: () => import('./pages/bulk-payment/bulk-payment.routes').then(m => m.BULK_PAYMENT_ROUTES)
      },
      {
        path: 'cash-management',
        loadChildren: () => import('./pages/cash-management/cash-management.routes').then(m => m.CASH_MANAGEMENT_ROUTES)
      },
      {
        path: 'scf',
        loadChildren: () => import('./pages/scf/scf.routes').then(m => m.SCF_ROUTES)
      },
      {
        path: 'bank-guarantee',
        loadChildren: () => import('./pages/bank-guarantee/bank-guarantee.routes').then(m => m.BANK_GUARANTEE_ROUTES)
      },
      {
        path: 'trade-finance',
        loadChildren: () => import('./pages/trade-finance/trade-finance.routes').then(m => m.TRADE_FINANCE_ROUTES)
      },
      {
        path: 'system-config',
        loadComponent: () => import('./pages/system-config/system-config.component').then(m => m.SystemConfigComponent)
      },
      {
        path: 'tier-config',
        loadComponent: () => import('./pages/tier-config/tier-config.component').then(m => m.TierConfigComponent)
      },
      {
        path: 'geography-config',
        loadComponent: () => import('./pages/geography-config/geography-config.component').then(m => m.GeographyConfigComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'login/veefin' }
];

